import { render, staticRenderFns } from "./PPersonalizeTable.vue?vue&type=template&id=6bd870d7&"
import script from "./PPersonalizeTable.vue?vue&type=script&lang=ts&"
export * from "./PPersonalizeTable.vue?vue&type=script&lang=ts&"
import style0 from "./PPersonalizeTable.vue?vue&type=style&index=0&id=6bd870d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports